import { ContractPartner } from '../../mdqx-graphql-types';
export class ContractPartnerEntity {
    public static readonly GqlFields = 'contractGroupTypeId contractId customerId id';

    public ContractGroupTypeId: number;
    public ContractId: number;
    public CustomerId: number;
    public Id: number;

    constructor(contractPartnerType: ContractPartner | null) {
        if (
            contractPartnerType &&
            contractPartnerType.contractGroupTypeId != null &&
            contractPartnerType.contractId != null &&
            contractPartnerType.customerId != null &&
            contractPartnerType.id != null
        ) {
            this.ContractGroupTypeId = contractPartnerType.contractGroupTypeId;
            this.ContractId = contractPartnerType.contractId;
            this.CustomerId = contractPartnerType.customerId;
            this.Id = contractPartnerType.id;
        } else {
            console.error('received broken ContractPartnerType', contractPartnerType);
            throw Error();
        }
    }
}
